<script lang="ts" setup>

defineOptions({
  inheritAttrs: false
})

const height = ref('auto')
onMounted(() => {
  const base = Math.floor(innerWidth / 375 * 16)
  document.documentElement.style.fontSize = base + 'px'

  const fn = () => requestAnimationFrame(() => {
    document.body.style.height = innerHeight + 'px'
    height.value = innerHeight + 'px'
  })
  window.addEventListener('resize', fn)
  window.addEventListener('orientationchange', fn)
  fn()
})

const { useRef } = useLayoutStore()
const [root] = useRef('root-container')

</script>

<template>
  <div class=" fixed t-0 h-full w-full flex flex-col" :style="{ height }">
    <slot name="top"></slot>
    <div class=" flex-1 overflow-auto scroll-smooth" v-bind="$attrs" ref="root">
      <slot></slot>
    </div>
    <slot name="bottom">
    </slot>
  </div>
</template>

<style lang="scss">
#h5 {
  font-size: 16px;
}

#h5 body {
  position: fixed;
  top: 0;
  height: 100vh;
  width: 100vw;
}
</style>
